import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/real-estate-commission',
  component: () => import('../../routes/RealEstateCommission.svelte'),
  card: {
    id: 'real-estate-commission',
    title: 'Real Estate Commission',
    description: 'Calculate agent commissions and net proceeds from selling a property.',
    icon: 'real_estate_agent',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/real-estate-commission',
    category: 'Real Estate',
  },
  seo: {
    title: 'Real Estate Commission Calculator – Agent Commission & Net Proceeds',
    description: 'Free real estate commission calculator. Calculate agent commissions, net proceeds, and closing costs when selling a home. See how much you keep after the 6% commission.',
  },
};

export default meta;
